import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const FeedbackCollector = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "feedback-collector" */ './hocs')),
    LoadingSkeleton: () => null,
});
